// Códigos de payment_method del backend ↔ nombres del maestro de formas de pago de Financiero
export const PAYMENT_METHOD_NAMES: Record<string, string> = {
  transfer:     'Transferencia bancaria',
  direct_debit: 'Domiciliación SEPA',
  sepa:         'Domiciliación SEPA',
  check:        'Cheque bancario',
  cash:         'Efectivo (Caja)',
  card:         'Tarjeta de crédito / débito'
};

export const paymentMethodName = (code: string): string => PAYMENT_METHOD_NAMES[code] || code || 'Transferencia bancaria';

// Un nombre sin código conocido (p. ej. "Pagaré comercial") se manda tal cual
export const paymentMethodCode = (name: string): string => {
  const entry = Object.keys(PAYMENT_METHOD_NAMES).find(code => PAYMENT_METHOD_NAMES[code] === name && code !== 'sepa');
  return entry || name;
};
